<template>
	<div class="header">
		<div class="content">
			<div class="header-left">
				<img class="logo" src="https://xinwendao.oss-cn-beijing.aliyuncs.com/uploads/image/2021bHc5ApegKm1624344264.png" />
				<span class="slogan">| 考研 就到新文道！</span>
			</div>
			<div class="header-right">
				<div v-if="!userInfo">
					<a href="javascript:void(0);" class="login" @click="gotoLogin">登录</a><b>|</b>
					<a href="javascript:void(0);" class="register" @click="gotoLogin">注册</a>
				</div>
				<el-dropdown v-if="userInfo">
					<div class="user_class">
						<img :src="userInfo.avatar" /><span class="userName">{{ userInfo.nickname }}</span>
						<i class="el-icon-arrow-down el-icon--right"></i>
					</div>
					<el-dropdown-menu>
							<el-dropdown-item @click.native="goUserCenter">个人中心</el-dropdown-item>
						<el-dropdown-item @click.native="userlogout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				
			</div>
			 

		</div>
	</div>
</template>
<script>
export default {
	name: 'Header',
	// inject:['reload'], 
	data(){
		return{
			userInfo: JSON.parse(localStorage.getItem('userInfo'))
		}
	},
	created(){
	},

	methods:{
		gotoLogin() {
			let url = process.env.VUR_APP_LOGING_URL + '/login?return_url=' + encodeURIComponent(window.location.href)
			window.open(url, '_self')
		},
		
		goUserCenter() {
			let url = process.env.VUR_APP_WEB_URL + '/member/study'
			window.open(url, '_self')
		},
		userlogout(){
			document.cookie = 'ssotoken=;domain=.xinwendao.cn;path=/;expires=' + new Date(0).toUTCString()
			localStorage.removeItem('studentToken')
			localStorage.removeItem('userInfo')
			this.$router.go(0);
			// this.reload()
		}
	}
}
</script>
<style lang="scss" scoped>
.header {
	height: 70px;
	line-height: 70px;
	position: fixed;
	top: 0;
	left: 0;
	background-color: #fff;
	width: 100%;
	z-index: 999;
	box-shadow: 0px 4px 8px 0px rgba(224, 224, 224, 0.2);

	.content {
		max-width: 1100px;
		height: 70px;
		line-height: 70px;
		margin-left: auto;
		margin-right: auto;
	}
	.header-left {
		float: left;
		height: 52px;
		margin-top: 10px;
		img {
			width: 130px;
			height: 36px;
		}
		.slogan {
			font-size: 17px;
			color: #666;
			margin-left: 14px;
			position: relative;
			white-space: nowrap;
			top: -10px;
			opacity: 1;
			transition: all 0.5s;
		}
	}
	.header-right {
		float: right;
	}
	.header-right a {
		font-size: 14px;
		width: 72px;
		height: 40px;
		border-radius: 20px;
		padding: 5px 20px;
	}
	.header-right .login {
		background: #e60013;
		color: #fff;
	}
	.header-right .register {
		border: 1px solid #f80010;
		color: #f82836;
	}
	.header-right b {
		margin: 0 10px;
		font-size: 14px;
		color: #666;
		font-weight: 100;
	}
}
.user_class img {
	width: 36px;
	height: 36px;
	line-height: 36px;
	vertical-align: middle;
	border-radius: 50%;
}
.userinfo {
	float: left;
	position: relative;
	margin-left: 26px;
	display: flex;
	align-items: center;
	> div {
		display: flex;
	}
	.menus {
		position: absolute;
		top: 80px;
		right: 5px;
		width: 140px;
		opacity: 0;
		/deep/ .el-card__body {
			padding: 0;
		}
		li {
			font-size: 15px;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
			// &:hover {
			// 	background-color: $primary-color-light;
			// }
		}
	}
	.nickname {
		height: 21px;
		font-size: 15px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(54, 56, 55, 1);
		line-height: 21px;
		margin-right: 25px;
	}
	.lnk-login {
		float: left;
		font-size: 16px;
		// color: $primary-color;
		height: 70px;
		white-space: nowrap;
		display: flex;
		align-items: center;
		&:hover > .menus {
			top: 70px;
			opacity: 255;
		}
	}
	.lnk-login-register {
		width: 72px;
		height: 32px;
		display: inline-block;
		border-radius: 18px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		line-height: 30px;
		text-align: center;
		box-sizing: border-box;
		cursor: pointer;
		&:first-child {
			margin-right: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue